import request from '../utils/fetch';

// 获取规则列表
export const getRules = async () => {
  return request('/model/v1/checkConflict/rule/boss/list', {
    // tokenFree: true,
    method: 'GET',
    params: {
      t: Date.now(),
    },
  });
};
// 获取规则详情
export const getRuleDetail = async (id: string) => {
  return request(`/model/v1/checkConflict/rule/boss/info/${id}`, {
    // tokenFree: true,
    method: 'GET',
  });
};

// 获取方向字典
export const getDirectionTypeDicts = async (type: string) => {
  return request(`/account/v1/dicts/groups/${type}`, {
    // tokenFree: true,
    method: 'GET',
    messageFree: true,
    params: {
      t: Date.now(),
    },
  });
};

//新增规则
export const addRule = async (params: addRuleParams) => {
  return request('/model/v1/checkConflict/rule/boss/add', {
    // tokenFree: true,
    method: 'POST',
    params: {
      t: Date.now(),
    },
    data: {
      ...params,
    },
  });
};

//复制规则
export const copyRule = async (ruleId: string) => {
  return request(`/model/v1/checkConflict/rule/boss/copy/${ruleId}`, {
    // tokenFree: true,
    method: 'POST',
    params: {
      t: Date.now(),
    },
  });
};

//删除规则
export const deleteRule = async (id: string) => {
  return request(`/model/v1/checkConflict/rule/boss/del/${id}`, {
    // tokenFree: true,
    method: 'DELETE',
    params: {
      t: Date.now(),
    },
  });
};

//发布、取消发布规则
export const publishRule = async (params: { published: boolean; ruleId: string }) => {
  return request('/model/v1/checkConflict/rule/boss/published/set', {
    // tokenFree: true,
    method: 'POST',
    params: {
      t: Date.now(),
    },
    data: {
      ...params,
    },
  });
};

//编辑规则
export const editRule = async (params: editRuleParams) => {
  return request(`/model/v1/checkConflict/rule/boss/update/${params.id}`, {
    // tokenFree: true,
    method: 'PUT',
    params: {
      t: Date.now(),
    },
    data: {
      ...params,
    },
  });
};
